<template>
  <div class="login">
    <div class="alert alert--success" v-if="isRegistered">
      Thank you for being a member with us. you will become a poor person after this decision.
    </div>
    <form class="form" @submit.prevent="registerFormHandler">
      <div class="form__row">

        <div class="form__group">
          <div class="form__control" :class="{ 'form__control--error': $v.register.firstname.$error }">
            <label class="form__label" for="firstName">{{ $t('register.firstName') }}</label>
            <input class="form__input" @blur="onBlurHandler('firstname')" type="text" id="firstName" v-model="$v.register.firstname.$model">
            <div class="form__error" v-if="!$v.register.firstname.required">{{ $t('register.validation.firstName') }}</div>
            <div class="form__error" v-if="!$v.register.firstname.minLength">{{ $t('register.validation.firstNameMinLength') }}</div>
          </div>
          <div class="form__control" :class="{ 'form__control--error': $v.register.lastname.$error }">
            <label class="form__label" for="lastName">{{ $t('register.lastName') }}</label>
            <input class="form__input" @blur="onBlurHandler('lastname')" type="text" id="lastName" v-model="$v.register.lastname.$model">
            <div class="form__error" v-if="!$v.register.lastname.required">{{ $t('register.validation.lastName') }}</div>
            <div class="form__error" v-if="!$v.register.lastname.minLength">{{ $t('register.validation.lastNameMinLength') }}</div>
          </div>
        </div>

        <div class="form__group">
          <div class="form__control" :class="{ 'form__control--error': $v.register.email.$error || serverSideErrors.length}">
            <label class="form__label" for="email">{{ $t('register.email') }}</label>
            <input class="form__input" @blur="onBlurHandler('email')" type="email" id="email" v-model="$v.register.email.$model">
            <div class="form__error" v-if="!$v.register.email.email">{{ $t('register.validation.email') }}</div>
            <div class="form__error" v-if="!$v.register.email.required">{{ $t('register.validation.emailIsRequired') }}</div>
            <div class="form__error" v-if="serverSideErrors.length">{{ $t('register.validation.emailIsExist') }}</div>
          </div>
          <div class="form__control" :class="{ 'form__control--error': $v.register.phone.$error }">
            <label class="form__label" for="tel">{{ $t('register.phone') }}</label>
            <input class="form__input" @blur="onBlurHandler('phone')" type="text" id="tel" v-model="$v.register.phone.$model" @keypress="isSwissPhoneNumber($event)">
            <div class="form__error" v-if="!$v.register.phone.required">{{ $t('register.validation.phone') }}</div>
            <div class="form__error" v-if="!$v.register.phone.minLength">{{ $t('register.validation.phoneMinLength') }}</div>
            <div class="form__error" v-if="!$v.register.phone.maxLength">{{ $t('register.validation.phoneMaxLength') }}</div>
          </div>
        </div>

        <div class="form__group">
          <div class="form__control" :class="{ 'form__control--error': $v.register.password.$error }">
            <label class="form__label" for="password">{{ $t('register.password') }}</label>
            <input class="form__input" @blur="onBlurHandler('password')" type="password" id="password" v-model="$v.register.password.$model">
            <div class="form__error" v-if="!$v.register.password.required">{{ $t('register.validation.password') }}</div>
            <div class="form__error" v-if="!$v.register.password.minLength">{{ $t('register.validation.passwordMinLength') }}</div>
          </div>
          <div class="form__control" :class="{ 'form__control--error': $v.register.password_confirmation.$error }">
            <label class="form__label" for="confirmPassword">{{ $t('register.confirmPassword') }}</label>
            <input class="form__input" @blur="onBlurHandler('password_confirmation')" type="password" id="confirmPassword" v-model="$v.register.password_confirmation.$model">
            <div class="form__error" v-if="!$v.register.password_confirmation.sameAsPassword">{{ $t('register.validation.confirmPassword') }}</div>
          </div>
        </div>

        <div class="form__group">
          <div class="form__control" :class="{ 'form__control--error': $v.register.street.$error }">
            <label class="form__label" for="street">{{ $t('register.street') }}</label>
            <input class="form__input" @blur="onBlurHandler('street')" type="text" id="street" v-model="$v.register.street.$model">
            <div class="form__error" v-if="!$v.register.street.required">{{ $t('register.validation.street') }}</div>
          </div>
          <div class="form__control" :class="{ 'form__control--error': $v.register.postalcode.$error }">
            <label class="form__label" for="zipCode">{{ $t('register.zipCode') }}</label>
            <input class="form__input" @blur="onBlurHandler('postalcode')" type="text" id="zipCode" v-model="$v.register.postalcode.$model">
            <div class="form__error" v-if="!$v.register.postalcode.required">{{ $t('register.validation.postalcode') }}</div>
            <div class="form__error" v-if="!$v.register.postalcode.minLength">{{ $t('register.validation.postalcodeMinLength') }}</div>
            <div class="form__error" v-if="!$v.register.postalcode.maxLength">{{ $t('register.validation.postalcodeMaxLength') }}</div>
          </div>
        </div>

        <div class="form__group">
          <div class="form__control" :class="{ 'form__control--error': $v.register.city.$error }">
            <label class="form__label" for="city">{{ $t('register.city') }}</label>
            <input class="form__input" @blur="onBlurHandler('city')"  type="text" id="city" v-model="$v.register.city.$model">
            <div class="form__error" v-if="!$v.register.city.required">{{ $t('register.validation.city') }}</div>
          </div>
        </div>

        <uploadImage @inputChange="handleImageUpload" />

      <div class="form__control form__control--checkbox" :class="{ 'form__control--error': $v.register.checkboxOne.$error }">
        <input type="checkbox" id="checkbox1" class="form__checkbox" v-model="$v.register.checkboxOne.$model">
        <label for="checkbox1" class="form__label">
          <span class="form__indicator" />
          <span class="form__text" v-html="$t('register.checkboxOne')"></span>
        </label>
      </div>

        <div class="form__control form__control--checkbox" :class="{ 'form__control--error': $v.register.checkboxTwo.$error }">
          <input type="checkbox" id="checkbox2" class="form__checkbox" v-model="$v.register.checkboxTwo.$model">
          <label for="checkbox2" class="form__label">
            <span class="form__indicator" />
            <span class="form__text" v-html="$t('register.checkboxTwo')"></span>
          </label>
        </div>


      </div>

      <div class="form__control">
        <button class="button button--primary" type="submit" :disabled="$v.register.$invalid">{{ $t('register.registerBtn') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { required, minLength, sameAs, email, maxLength } from 'vuelidate/lib/validators'
  import uploadImage from '@/components/AppUploadImage'
  export default {
    name: "Register",
    components: {
      uploadImage
    },
    validations: {
      register: {
        firstname: {
          required,
          minLength: minLength(3)
        },
        lastname: {
          required,
          minLength: minLength(3)
        },
        phone: {
          minLength: minLength(10),
          maxLength: maxLength(30)
        },
        email: {
          required,
          email
        },
        password: {
          required,
          minLength: minLength(6)
        },
        password_confirmation: {
          sameAsPassword: sameAs('password')
        },
        street: {

        },
        postalcode: {

          minLength: minLength(4),
          maxLength: maxLength(6)
        },
        city: {
          
        },
        checkboxOne: {
          sameAs: sameAs( () => true )
        },
        checkboxTwo: {
          sameAs: sameAs( () => true )
        },
      }
    },
    data() {
      return {
        isRegistered: false,
        serverSideErrors: [],
        register: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          password: '',
          password_confirmation: '',
          street: '',
          postalcode: '',
          city: '',
          checkboxOne: null,
          checkboxTwo: null,
        }
      }
    },
    methods: {
      ...mapActions('auth', ['fetchCurrentUser', 'registerHandler']),
      handleImageUpload(value) {
        this.register.base64_image = value
      },
      onBlurHandler(fieldName) {
        this.$v.register[fieldName].$touch();
      },
      isSwissPhoneNumber(e) {
        let t = e.target;
        if (t.hasAttribute('maxlength')) {
          t.value = t.value.slice(0, t.getAttribute('maxlength'));
        }
      },
      registerFormHandler() {
        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        } else {
          this.$v.$reset();
          this.serverSideErrors = [];
          this.registerHandler(this.register)
          .then(res => {
            this.register = {}
            res.success ? this.isRegistered = true : false
            this.$router.push('/')
          })
          .catch(e => {
            this.serverSideErrors = e.message.email
          })
        }
      }
    }
  }
</script>
